import { render } from "./Sunset.vue?vue&type=template&id=107826cd&scoped=true"
import script from "./Sunset.vue?vue&type=script&lang=js"
export * from "./Sunset.vue?vue&type=script&lang=js"

import "./Sunset.vue?vue&type=style&index=0&id=107826cd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107826cd"]])

export default __exports__